import React from 'react'
import { t } from '@/i18n'
import BooleanRow from '@/pages/Main/components/BooleanRow'

interface Props {
  node: any
}

const defaultRow = ({ value }: { value: any }) => <b>{value}</b>

const typeComponentMap = {
  checkbox: BooleanRow,
}

const DetailsRow: React.FC<Props> = ({ node }) => {
  // @ts-ignore
  const Component = typeComponentMap[node.type] || defaultRow
  return (
    <li>
      {t(node.label || '')}
      <span>
        <Component {...node} />
      </span>
    </li>
  )
}

export default DetailsRow
